import { useEffect } from "react";

/**
 * Fecha um painel lateral (sino, menu da conta) com a tecla Esc enquanto ele está aberto.
 * Se houver uma janela por cima (confirmação ou modal), o Esc é dela e o painel não fecha.
 */
export function useFecharComEsc(aberto: boolean, aoFechar: () => void) {
  useEffect(() => {
    if (!aberto) return;
    function aoTeclar(e: KeyboardEvent) {
      if (e.key !== "Escape") return;
      if (document.getElementById("confirmacao-titulo") || document.getElementById("modal-titulo")) return;
      aoFechar();
    }
    document.addEventListener("keydown", aoTeclar);
    return () => document.removeEventListener("keydown", aoTeclar);
  }, [aberto, aoFechar]);
}
